import { connect } from 'react-redux'
import { FileUploadZoneComponent } from './FileUploadZone'
import { PreviewUploadZoneComponent } from './PreviewUploadZone'
import { AppStateType } from '../../reducers'
import { selectFile } from '../../selectors/file'
import { selectPackId, selectEditions } from '../../selectors/pack'

const mapStateToFileUploadZoneProps = (state: AppStateType) => ({
  file: selectFile(state),
  packId: selectPackId(state),
  editions: selectEditions(state),
})

export const FileUploadZone = connect(mapStateToFileUploadZoneProps)(
  FileUploadZoneComponent
)

const mapStateToPreviewUploadZoneProps = (state: AppStateType) => ({
  file: selectFile(state),
})

export const PreviewUploadZone = connect(mapStateToPreviewUploadZoneProps)(
  PreviewUploadZoneComponent
)
